import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import SupportArticlePanel from "components/SupportArticlePanel/SupportArticlePanel";
import { ExcelTemplateDetailSection } from "exceltemplate/ExcelTemplateDetailSection";
import ExcelTemplateOptionsPanel from "exceltemplate/ExcelTemplateOptionsPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { ExcelTemplateActivityPanel } from "./activity/ExcelTemplateActivityPanel";

const ExcelTemplateDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ExcelTemplateDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <ExcelTemplateDetailSection
            excelTemplate={viewModel.excelTemplate}
            availableMergeFieldTopics={viewModel.availableMergeFieldTopics}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <ExcelTemplateOptionsPanel
            optionsPanelData={viewModel.optionsPanel}
            listUrl={viewModel.listUrl}
            excelTemplateId={viewModel.excelTemplate.excelTemplateId}
          />
          <SupportArticlePanel
            config={viewModel.articlePanelConfig}
          />
          <ExcelTemplateActivityPanel
            config={viewModel.activityPanelConfig}
            excelTemplateId={viewModel.excelTemplate.excelTemplateId}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>
}

export default ExcelTemplateDetailApp;